import { VideoStatus } from '@/enum/enum'
import { Media } from '@/payload-types'
import MuxPlayer from '@mux/mux-player-react/lazy'
import { VideoIcon, VideoOff } from 'lucide-react'

const MuxVideoPlayer = ({ videoData, timeStamp }: { videoData: Media, timeStamp?: string | null }) => {
  const videoPoster =
    videoData.coverImage && typeof videoData.coverImage === 'object'
      ? `${process.env.NEXT_PUBLIC_PAYLOAD_URL ?? ''}${
          videoData.coverImage.sizes?.medium?.url
        }`
      : (videoData.coverImage as string)
      
  return (
    <div className="h-full flex items-center rounded-lg overflow-hidden ">
     {videoData.mux?.status === VideoStatus.READY && <MuxPlayer
        playbackId={videoData.mux?.playbackId || ''}
        poster={videoPoster}
        accentColor="#C13D20"
        style={{ aspectRatio: 16 / 9 }}
        startTime={timeStamp ? Number(timeStamp) : 0}
        metadata={{
          video_id: videoData.mux?.assetId || '',
          video_title: videoData.title,
        }}
      /> }
      {/* {videoData.mux?.status === VideoStatus.PENDING && <MuxVideoPlayerLoading />} */}
      {videoData.mux?.status === VideoStatus.FAILED && <MuxVideoPlayerFailed />}
    </div>
  )
}
const MuxVideoPlayerLoading = () => {
  return (
    <div className="relative aspect-video w-full max-w-4xl overflow-hidden rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center p-6 text-center">
      <div className="flex flex-col items-center gap-4">
        {/* Icon Container */}
        <div className="rounded-full bg-gray-200 p-4">
          <VideoIcon className="h-10 w-10 text-gray-500" />
        </div>

        {/* Text Content */}
        <div className="space-y-1">
          <h3 className="text-xl font-bold tracking-tight text-gray-700 uppercase">
            Upload In Progress
          </h3>
          <p className="text-sm text-gray-500 max-w-xs">
            Media is being processed. Please check back soon.
          </p>
        </div>
      </div>
    </div>
  );
}

const MuxVideoPlayerFailed = () => {
  return (
    <div className="relative aspect-video w-full max-w-4xl overflow-hidden rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center p-6 text-center">
      <div className="flex flex-col items-center gap-4">
        {/* Icon Container */}
        <div className="rounded-full bg-gray-200 p-4">
          <VideoOff className="h-10 w-10 text-gray-500" />
        </div>

        {/* Text Content */}
        <div className="space-y-1">
          <h3 className="text-xl font-bold tracking-tight text-gray-700 uppercase">
            Upload Failed
          </h3>
          <p className="text-sm text-gray-500 max-w-xs">
            Media unavailable. Please remove and re-upload or contact IT.
          </p>
        </div>
      </div>
    </div>
  );
}

export default MuxVideoPlayer
